import React from 'react';
import classNames from 'classnames';
import {Field, reduxForm} from 'redux-form';

import {USE_RECAPTCHA_ON_LOGIN} from 'appConstants';

import ErrorBlock from 'components/ErrorBlock';
import Button from 'components/Button';

import {EmailField, PasswordField} from 'components/Fields';

import RecaptchaField from './components/RecaptchaField';

import {required} from 'utils/validators';
import {loginRequest} from 'ducks/auth';

import './styles.css';

const formSubmit = (values, dispatch) => {
  dispatch(loginRequest(values));
};

const LoginForm = ({
  handleSubmit,
  submitting,
  className,
  error,
  children,
  submit
}) => {
  const triggerSubmit = () => {
    submit('login');
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={classNames(className, 'LoginForm')}>
      <Field
        placeholder="Email"
        name="email"
        component={EmailField}
        validate={[required]}
      />
      <Field
        placeholder="Password"
        name="password"
        component={PasswordField}
        validate={[required]}
      />
      {USE_RECAPTCHA_ON_LOGIN && (
        <Field
          name="recaptcha"
          component={RecaptchaField}
          validate={[required]}
        />
      )}
      {error && <ErrorBlock>{error}</ErrorBlock>}
      <Button
        onClick={triggerSubmit}
        className="submit"
        blue={!submitting}
        isLoading={submitting}
        disabled={submitting}>
        Login →
      </Button>
      {children}
    </form>
  );
};

export default reduxForm({form: 'login', onSubmit: formSubmit})(
  LoginForm as React.ComponentType<any>
) as React.ComponentType<any>;
